export default function newSyncableSectionTitleChangeDirective() {
  return {
    template: require('./new-syncable-section-title-change.html'),
    restrict: 'E',
    controller: 'NewSyncableSectionTitleChangeController',
    controllerAs: 'newSyncableSectionTitleChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
      isBatch: '=',
    },
  };
}
